import {
  DndContext,
  PointerSensor,
  useSensor,
  useSensors,
  DragEndEvent,
  DragOverEvent,
  pointerWithin
} from '@dnd-kit/core'
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable'
import { useFFEStore } from '../../store/ffeStore'
import { SortableLineItem } from '../LineItem/SortableLineItem'
import { GroupContainer } from '../Groups/GroupContainer'
import { arrayMove } from '../../utils/array'
import { AddLineItemButton } from '../LineItem/AddLineItemButton'
import { useDebouncedCallback } from 'use-debounce'

export const LineItemList = () => {
  const lineItems = useFFEStore((state) => state.document.lineItems)
  const groups = useFFEStore((state) => state.document.groups)
  const reorderLineItems = useFFEStore((state) => state.reorderLineItems)
  const reorderGroups = useFFEStore((state) => state.reorderGroups)
  const updateLineItem = useFFEStore((state) => state.updateLineItem)
  const updateGroup = useFFEStore((state) => state.updateGroup)
  const debounceUpdateLineItem = useDebouncedCallback(updateLineItem, 4)
  const debounceUpdateGroup = useDebouncedCallback(updateGroup, 4)

  const sensors = useSensors(useSensor(PointerSensor))

  const handleDragEnd = (event: DragEndEvent) => {
    const { active, over } = event

    if (!active || !over || active.id === over.id) return

    const activeType = active.data.current?.type
    const overType = over.data.current?.type

    console.log(activeType, overType)

    // Handle group reordering
    if (activeType === 'group' && overType === 'group') {
      const activeGroup = groups.find((item) => item.id === active.id)
      const overGroup = groups.find((item) => item.id === over.id)

      console.log(activeGroup?.id, overGroup?.id)
      if (
        activeGroup &&
        overGroup &&
        activeGroup.groupId === overGroup.groupId
      ) {
        const oldIndex = groups.findIndex((group) => group.id === active.id)
        const newIndex = groups.findIndex((group) => group.id === over.id)

        if (oldIndex !== -1 && newIndex !== -1) {
          const newGroups = arrayMove(groups, oldIndex, newIndex)
          reorderGroups(newGroups)
        }
      }
      return
    }

    // Handle line item reordering
    if (activeType === 'item' && overType === 'item') {
      const activeItem = lineItems.find((item) => item.id === active.id)
      const overItem = lineItems.find((item) => item.id === over.id)

      if (activeItem && overItem && activeItem.groupId === overItem.groupId) {
        const oldIndexOfActiveItem = lineItems.findIndex(
          (item) => item.id === active.id
        )
        const newIndexOfActiveItem = lineItems.findIndex(
          (item) => item.id === over.id
        )

        if (oldIndexOfActiveItem !== -1 && newIndexOfActiveItem !== -1) {
          const newItems = arrayMove(
            lineItems,
            oldIndexOfActiveItem,
            newIndexOfActiveItem
          )

          reorderLineItems(newItems)
        }
      }
    }
  }

  const handleDragOver = (event: DragOverEvent) => {
    const { active, over } = event

    if (!active || !over || active.id === over.id) return

    const activeType = active.data.current?.type
    const overType = over.data.current?.type

    if (activeType === 'item' && overType === 'group') {
      debounceUpdateLineItem(active.id.toString(), {
        groupId: over.id.toString()
      })
    }

    if (activeType === 'item' && overType === 'item') {
      const overItem = lineItems.find((item) => item.id === over.id)
      if (overItem) {
        debounceUpdateLineItem(active.id.toString(), {
          groupId: overItem.groupId
        })
      }
    }

    // if (activeType === 'group' && overType === 'group') {
    //   console.log('group to group')
    //   const activeGroup = groups.find((group) => group.id === active.id)
    //   const overGroup = groups.find((group) => group.id === over.id)

    //   console.log(activeGroup, overGroup)

    //   if (activeGroup && overGroup) {
    //     updateGroup(activeGroup.id.toString(), { groupId: overGroup.groupId })
    //   }
    // }

    if (activeType === 'group' && overType === 'item') {
      console.log('group to group')
      const overItem = lineItems.find((item) => item.id === over.id)

      if (overItem && overItem.groupId !== active.id) {
        debounceUpdateGroup(active.id.toString(), { groupId: overItem.groupId })
      }
    }
  }

  const ungroupedItems = lineItems.filter((item) => !item.groupId)
  const ungroupedGroups = groups.filter((group) => !group.groupId)

  return (
    <div className="space-y-4">
      <DndContext
        sensors={sensors}
        collisionDetection={pointerWithin}
        onDragEnd={handleDragEnd}
        onDragOver={handleDragOver}
      >
        <div className="space-y-4">
          <SortableContext
            items={ungroupedGroups}
            strategy={verticalListSortingStrategy}
          >
            {ungroupedGroups.map((group) => (
              <GroupContainer key={group.id} group={group} depth={0} />
            ))}
          </SortableContext>

          <SortableContext
            items={ungroupedItems}
            strategy={verticalListSortingStrategy}
          >
            {ungroupedItems.map((item) => (
              <SortableLineItem key={item.id} item={item} />
            ))}
          </SortableContext>
        </div>
      </DndContext>

      <AddLineItemButton />
    </div>
  )
}
